import type {Quantity} from '@/types/api/quantity.type'

const getBaseQuantity = (object: {baseQuantity: number; quantities: [Quantity]}) => {
  return object.quantities.find(item => item.id === object.baseQuantity)
}

export {getBaseQuantity}
